import React, { memo, useCallback, useEffect, useReducer, useMemo } from 'react';
import { Modal, Text } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

const initialState = {
    onConfirm: null,
    warningText: '',
    isOpen: false,
};

function reducer(state, action) {
    switch (action.type) {
        case 'init':
            return {
                ...state,
                onConfirm: action.onConfirm,
                warningText: action.warningText,
                warningTitle: action.warningTitle,
                isOpen: true,
            };
        case 'close':
            return { ...state, isLoading: false, isOpen: false };
        default:
            throw new Error('No action provided');
    }
}

const WarningChangeModal = memo(({ onRef }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        onRef &&
            onRef({
                open({ onConfirm, warningText, warningTitle }) {
                    dispatch({
                        type: 'init',
                        onConfirm,
                        warningTitle,
                        warningText,
                    });
                },
            });
    }, [onRef]);

    const onCancel = useCallback(() => dispatch({ type: 'close' }), []);

    const onInnerConfirm = useCallback(() => {
        state.onConfirm();
        onCancel();
    }, [onCancel, state]);

    const overridesModal = useMemo(
        () => ({
            confirmButton: {
                type: 'primary-error',
            },
        }),
        [],
    );

    return (
        <Modal
            className="fm-warning-change-modal"
            overlayClassName="fm-warning-change-modal__overlay"
            size="small"
            useCornerClose={false}
            isOpen={state.isOpen}
            onCancel={onCancel}
            onConfirm={onInnerConfirm}
            confirmText={getLiteral('action_continue')}
            cancelText={getLiteral('action_cancel')}
            title={state.warningTitle || getLiteral('title_warning')}
            overrides={overridesModal}
        >
            <Text>{state.warningText}</Text>
        </Modal>
    );
});

export default WarningChangeModal;
